export const updateArrayItem = (array, updatedItem, key = 'id') =>
  array.map((item) => (item[key] === updatedItem[key] ? updatedItem : item));

export const removeArrayItem = (array, deletedItem, key = 'id') =>
  array.filter((item) => item[key] !== deletedItem[key]);

export const moveArrayItem = (array, oldIndex, newIndex) => {
  const newArray = [...array];
  const element = newArray[oldIndex];
  newArray.splice(oldIndex, 1);
  newArray.splice(newIndex, 0, element);
  return newArray;
};

export const reorderSequenceByIndex = (array, oldIndex, newIndex) => {
  let newArray = [...array];
  if (oldIndex > newIndex) {
    // if pushing backwards
    const difference = oldIndex - newIndex;
    for (let i = 0; i <= difference; i++) {
      newArray[oldIndex - i].sequence += 1;
      newArray[oldIndex].sequence = newIndex + 1;
    }
    newArray = moveArrayItem(newArray, oldIndex, newIndex);
  }

  if (oldIndex < newIndex) {
    // if pushing forwards
    const difference = newIndex - oldIndex;
    for (let i = 0; i <= difference; i++) {
      newArray[oldIndex + i].sequence -= 1;
      newArray[oldIndex].sequence = newIndex + 1;
    }
    newArray = moveArrayItem(newArray, oldIndex, newIndex);
  }
  return newArray;
};
